import { Typography } from "@mui/material";
import { maturityLevelColors } from "@features/assessments-feature/utils/assessmentsColors";
import { getMaturityIcon } from "@features/assessments-feature/helpers/assessmentMaturityChartHelpers";
import React from "react";
import { AssessmentProgram } from "@lib/ShiOneClient";
import { transformMaturityLabelForDisplay } from "@features/assessments-feature/utils/maturityScoreUtils";

const MaturityLabelWithIcon = ({
  maturityValue,
  program,
}: {
  maturityValue: string;
  program?: AssessmentProgram | string;
}) => {
  const displayLabel = transformMaturityLabelForDisplay(maturityValue, program);

  return (
    <Typography
      component={"div"}
      display={"flex"}
      alignItems="center"
      variant={"body2"}
      color={maturityLevelColors[maturityValue]}
    >
      {getMaturityIcon(maturityValue)}
      {displayLabel}
    </Typography>
  );
};

export default MaturityLabelWithIcon;
